import { ButtonComponent } from '@agilox/ui';
import {
	AfterViewInit,
	Component,
	input,
	OnDestroy,
	output,
	signal,
	viewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'ui-confirmation-content',
	imports: [ButtonComponent, TranslateModule],
	templateUrl: './confirmation-content.component.html',
})
export class ConfirmationContentComponent implements OnDestroy, AfterViewInit {
	//https://github.com/angular/angular/issues/60574
	private destroyed = false;

	bodyText = input<string>('');
	submitButtonText = input<string>('');
	disabled = input<boolean>(false);

	confirmed = output<void>();
	cancelled = output<void>();
	closed = output<void>();

	confirmButton = viewChild<ButtonComponent>('confirmButton');

	focused = signal<boolean>(false);

	ngOnDestroy(): void {
		this.destroyed = true;
	}

	onSubmit() {
		if (!this.destroyed) this.confirmed.emit();
		this.close();
	}

	onCancel() {
		if (!this.destroyed) this.cancelled.emit();
		this.close();
	}

	private close() {
		if (!this.destroyed) this.closed.emit();
	}

	ngAfterViewInit() {
		setTimeout(() => this.confirmButton()?.focus());
	}
}
